export const it_IT = {
  translation: {
    add_to_cart: "Aggiungi articolo al carrello",
    save: "Salva",
    load: "Carica articolo",
    title: "Configurazione",
    type_key: "Chiave di tipo",
    start: "Inizia",
    generate_document: "Crea scheda tecnica",
    sap_button: "Crea articolo in SAP",
    cad_button: "Crea dati CAD",
    reset_configuration: "Ripristina configurazione",
    show_additional_information: "Mostra informazioni aggiuntive",
    sap_title: "SAP",
    close_configuration_button: "Chiudi",
    no_results_found: "Nessun risultato trovato",
    load_configuration_dialog: {
      title: "Carica configurazione – Imposta parametri di ricerca",
      cancel: "Annulla",
      search: "Cerca",
      start_date: "Data di creazione da",
      end_date: "a",
      guid: "GUID",
      material_number: "Numero di materiale",
      order_code: "Codice ordine",
      creator: "Creatore",
      description: "Descrizione",
      info_artikel: "Articolo informativo",
      short_text: "Testo breve",
      version: "Versione",
      status: "Stato",
      update_user: "Aggiornato da",
      createdDate: "Data di creazione",
      saved_records: "Record salvati",
      back: "Indietro",
      open: "Apri",
      rows_per_page: "Righe per pagina:",
    },
    error: {
      ERROR_LOAD_DATA_ERROR: "(CARICAMENTO) fallito (dati errati o incompleti)",
      ERROR_SAVE_DATA_ERROR: "(SALVATAGGIO) fallito (dati errati o incompleti)",
      ERROR_LOAD_ID: "ID da caricare non trovato",
      ERROR_LOAD_ID_CONFIG:
        "Errore dal configuratore durante il caricamento di un progetto",
      ERROR_LOADSTART_CONFIG: "Errore dal configuratore all'avvio",
      ERROR_MISSING_VALUES:
        "Messaggio di errore generale se la validazione dei dati frontend fallisce",
      ERROR_COOKIE_SERVICE_INITIAL:
        "Inizializzazione del servizio cookie fallita",
      ERROR_COOKIE_GENERAL: "Errore nel servizio cookie",
      ERROR_TOKEN_NOT_FOUND: "Token non trovato",
      ERROR_ID_BLOCKED:
        "L'articolo è in fase di modifica, modifiche non possibili",
      ERROR_DB_SAVE: "Errore durante il salvataggio dei dati nel database",
      ERROR_LOAD_VALID:
        "Caricamento configurazione non riuscito, dati non validi",
      ERROR_NONE_LOAD_ID_FOUND_SAP_CHECK:
        "ID non trovato, controllo SAP non riuscito",
      ERROR_NONE_LOAD_ID_FOUND_ROWID_FROM_SHOPID:
        "Nessun numero materiale trovato per l'ID dal shop ID",
      ERROR_DELETE_CONFIGURATION:
        "Errore durante l'eliminazione della configurazione",
      ERROR_DEFINITION_SECRET_JWT: "Definizione JWT mancante",
      ERROR_PATH_NOT_DEFINED: "Percorso non definito",
      ERROR_BACKLINK_URL: "URL di ritorno non definito",
      ERROR_POSITIONDATA_EMPTY: "I dati di posizione sono vuoti",
      ERROR_SHOP_ID: "ID negozio non trovato",
      ERROR_CADBOXDATA_EMPTY: "Nessun dato CAD box trovato",
      ERROR_NONE_LOAD_ID_FOUND: "Nessun ID da caricare trovato",
      ERROR_NONE_ACCEPTABLE_ID: "Nessun ID accettabile trovato",
    },
    sap: {
      create_error: "Errore durante la creazione",
      create_success: "Creato con successo",
    },
    button: {
      save: "Salva",
      cancel: "Annulla",
    },
  },
};

export default it_IT;
